const EMPTY_TRUNCATED = {
    encounters: false,
    vaccinations: false,
    labExams: false,
    hospitalizations: false,
    prescriptions: false
};
const EMPTY_PAGE = () => ({ cursor: null, hasMore: true, loading: false, error: null, generation: 0 });

export default {
    setEncounterContentRevision(state, { encounterId, contentRevision }) {
        if (state.selectedEncounter && state.selectedEncounter.id === encounterId && Number.isInteger(contentRevision)) {
            state.selectedEncounter = { ...state.selectedEncounter, contentRevision };
        }
    },
    setEncounters(state, encounters) {
        state.encounters = encounters || [];
    },
    appendEncounters(state, encounters) {
        state.encounters = (state.encounters || []).concat(encounters || []);
    },
    setEncountersCursor(state, cursor) {
        state.encountersCursor = cursor || null;
    },
    setHasMoreEncounters(state, hasMore) {
        state.hasMoreEncounters = !!hasMore;
    },
    setLoadingEncounters(state, loading) {
        state.loadingEncounters = !!loading;
    },
    setSelectedEncounter(state, encounter) {
        state.selectedEncounter = encounter || null;
    },
    setAnamnesis(state, anamnesis) {
        state.anamnesis = anamnesis || null;
    },
    setPhysicalExam(state, physicalExam) {
        state.physicalExam = physicalExam || null;
    },
    setDiagnoses(state, diagnoses) {
        state.diagnoses = diagnoses || [];
    },
    setVaccinations(state, vaccinations) {
        state.vaccinations = vaccinations || [];
    },
    setVaccinationSchedule(state, schedule) {
        state.vaccinationSchedule = schedule || [];
    },
    setLoadingVaccinations(state, loading) {
        state.loadingVaccinations = !!loading;
    },
    setLabExams(state, labExams) {
        state.labExams = labExams || [];
    },
    setLoadingLabExams(state, loading) {
        state.loadingLabExams = !!loading;
    },
    setHospitalizations(state, hospitalizations) {
        state.hospitalizations = hospitalizations || [];
    },
    setLoadingHospitalizations(state, loading) {
        state.loadingHospitalizations = !!loading;
    },
    setPrescriptions(state, prescriptions) {
        state.prescriptions = prescriptions || [];
    },
    setLoadingPrescriptions(state, loading) {
        state.loadingPrescriptions = !!loading;
    },
    setPagination(state, { type, patch } = {}) {
        if (!type || !state.pagination[type]) return;
        state.pagination = {
            ...state.pagination,
            [type]: { ...state.pagination[type], ...(patch || {}) }
        };
        // Mantem os getters legados consumidos por telas ja publicadas.
        if (type === 'encounters') {
            state.encountersCursor = state.pagination[type].cursor;
            state.hasMoreEncounters = state.pagination[type].hasMore;
            state.loadingEncounters = state.pagination[type].loading;
        }
        const loadingKey = { vaccinations: 'loadingVaccinations', labExams: 'loadingLabExams', hospitalizations: 'loadingHospitalizations', prescriptions: 'loadingPrescriptions' }[type];
        if (loadingKey) state[loadingKey] = state.pagination[type].loading;
    },
    /**
     * Marca que a lista de um tipo veio no limite da pagina do backend.
     * A substituicao do objeto inteiro mantem a reatividade no Vue 2.
     */
    setTruncated(state, { type, value } = {}) {
        if (!type) return;
        state.truncated = { ...state.truncated, [type]: !!value };
    },
    setTimelineFilter(state, filter) {
        state.timelineFilter = filter || 'all';
    },
    setHideDrafts(state, value) {
        state.hideDrafts = !!value;
    },
    clearRecords(state) {
        state.encounters = [];
        state.encountersCursor = null;
        state.hasMoreEncounters = true;
        state.loadingEncounters = false;
        state.selectedEncounter = null;
        state.anamnesis = null;
        state.physicalExam = null;
        state.diagnoses = [];
        state.vaccinations = [];
        state.vaccinationSchedule = [];
        state.loadingVaccinations = false;
        state.labExams = [];
        state.loadingLabExams = false;
        state.hospitalizations = [];
        state.loadingHospitalizations = false;
        state.prescriptions = [];
        state.loadingPrescriptions = false;
        state.pagination = {
            encounters: EMPTY_PAGE(), vaccinations: EMPTY_PAGE(), labExams: EMPTY_PAGE(),
            hospitalizations: EMPTY_PAGE(), prescriptions: EMPTY_PAGE()
        };
        state.truncated = { ...EMPTY_TRUNCATED };
        state.timelineFilter = 'all';
        state.hideDrafts = false;
    }
}
